import React, { useEffect, useState } from 'react'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import CustomInput from '../../../Components/InputCompo/CustomInput'
import CustomSelection from '../../../Components/SelectionComp/CustomSelection'
import ButtonComp from '../../../Components/ButtonComp/ButtonComp'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import { Donation as documents} from './Documents'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import { ContributionGet, EOIGet } from '../../../Store/auth/register'
import { useQuery } from '@tanstack/react-query'
import CustomFileInput from '../../../Components/InputCompo/CustomFileInput'
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import Loading from '../../../Components/Loader/Loading'

const DonationDocuments = ({setSubTabs}) => {
    const [initialValues, setInitialValues] = useState({});

    const gsnNoFromStorage = localStorage.getItem('gsn_no');

    const { data: EoiQuestions } = useQuery({
        queryKey: 'EOI',
        queryFn: () => EOIGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
    });

    if (!EoiQuestions) {
        setSubTabs({ "Organisation Details": true })
    }

    const { data: questions , isLoading} = useQuery({
        queryKey: 'Contribution',
        queryFn: () => ContributionGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
    });
    // 

    const [attachmentUrls, setAttachmentUrls] = useState({});

    useEffect(() => {
        // Convert base64 to Blob URL for all attachment fields dynamically
        const base64ToUrl = (base64) => {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length).fill(null).map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' }); // Use appropriate MIME type if not PDF
            return URL.createObjectURL(blob);
        };

        // Dynamically generate URLs for all attachments
        const urls = {};
        documents.forEach((field) => {
            if (field.type.toLowerCase() === 'attach' && questions?.documents?.[field.question_no]) {
                urls[field.question_no] = base64ToUrl(questions.documents[field.question_no]);
            }
        });
        setAttachmentUrls(urls);
    }, [questions]);


    const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
            if (field.mandatory === 1 && field.type.toLowerCase() !== 'section') {
                let validator = Yup.string().required(`${field.question} is required`);

                if (field.validation) {
                    switch (field.validation.toLowerCase()) {
                        case 'email':
                            validator = Yup.string()
                                .email('Invalid email address')
                                .required(`${field.question} is required`);
                            break;
                        case 'number':
                            validator = Yup.string()
                                .matches(/^\d{10}$/, "Invalid Number. It should be 10 digits.")
                                .required(`${field.question} is required`);
                            break;
                        case 'pan':
                            validator = Yup.string()
                                .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number. It should be in the format: ABCDE1234F.')
                                .required(`${field.question} is required`);
                            break;
                        case 'pincode':
                            validator = Yup.string()
                                .matches(/^\d{4}$|^\d{6}$/, 'PIN code must be exactly 6 digits')
                                .required(`${field.question} is required`);
                            break;
                        case 'areacode':
                            validator = Yup.string()
                                .matches(/^(123|456|789)$/, 'Incorrect area code')
                                .required(`${field.question} is required`);
                            break;
                        case 'website':
                            validator = Yup.string()
                                .url('Please enter a valid URL')
                                .required(`${field.question} is required`);
                            break;
                        case 'mobile':
                            validator = Yup.string()
                                .matches(/^[0-9]{10}$/, 'Invalid mobile number')
                                .required(`${field.question} is required`);
                            break;
                        case 'darpan':
                            validator = Yup.string()
                                .test(
                                    'is-valid-darpan',
                                    'Darpan Id should be in the format: XX/1234/1234567',
                                    (value) => value?.toUpperCase() === 'NA' || /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                                )
                                .required(`${field.question} is required`);
                            break;
                        case 'password':
                            validator = Yup.string()
                                .min(8, 'Password must be at least 8 characters long')
                                .required(`${field.question} is required`);
                            break;
                        case 'multiselect dropdown':
                            validator = Yup.array().required(`${field.question} is required`);
                            break;
                        case 'attach':
                            validator = Yup.object().required(`${field.question} is required`);
                            break;
                        case 'amount':
                            validator = Yup.string()
                                .matches(/^\d+$/, 'Amount of Donation should contain only numerals')
                                .max(20, 'Amount of Donation can be up to 20 digits only')
                                .required(`${field.question} is required`);
                            break;
                        default:
                            validator = Yup.string().required(`${field.question} is required`);
                            break;
                    }
                }


                schema[field.question_no] = validator;
            }

            return schema;
        }, {})
    );


    useEffect(() => {
        const savedData = JSON.parse(localStorage.getItem('ContributionData')) || {};

        const apiData = questions?.documents || {};

        const formValues = {
            ...(documents && documents.length > 0
                ? documents.reduce((acc, field) => {
                    acc[field.question_no] = apiData[field.question_no] || savedData[field.question_no] || '';
                    return acc;
                }, {})
                : {}
            ),
        };

        setInitialValues(formValues);
    }, [questions]); // Ensure questions is being updated correctly





    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Prepare the tempData
                const tempData = {
                    ...documents.reduce((acc, field) => {
                        acc[field.question_no] = values[field.question_no];
                        return acc;
                    }, {}),
                    
                };

                // Retrieve existing data from localStorage
                const existingAPIData = JSON.parse(localStorage.getItem('ContributionDataAPI')) || {};
                const existingUserData = JSON.parse(localStorage.getItem('ContributionDataUser')) || {};

                // Merge data
                const updatedData = {
                    ...existingUserData,
                    'donor_payment_details': [
                        ...(existingUserData.donor_payment_details || []),
                        tempData, // user-altered data
                    ],
                };

                // Check if ContributionDataAPI is stored in localStorage, if not, store existingAPIData
                if (!localStorage.getItem('ContributionDataAPI')) {
                    localStorage.setItem('ContributionDataAPI', JSON.stringify(existingAPIData));
                }

                // Save the updated user data to localStorage
                localStorage.setItem('ContributionData', JSON.stringify(updatedData));

                // Dynamically move to the next tab
                

            } catch (error) {
                console.error('Submission error:', error);
            } finally {
                setSubmitting(false);
            }
        },
    });
    if (isLoading) return (<Loading />)



    // 
    
  return (
    <>
            <form className='flex flex-col gap-[30px]' action="" onSubmit={formik.handleSubmit}>
                <div className='flex flex-col gap-[30px]'>
                    
                    <div className='w-[100%] flex-wrap flex gap-[24pt]'>
                        {documents.slice(0, 7).map(Fields =>
                            <>
                                {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                                    <div className='w-[47%]'>
                                        <CustomInput
                                            required
                                            {...formik.getFieldProps(Fields.question_no)}
                                            name={Fields.question_no} label={Fields.question} type={Fields.type}
                                            onBlur={formik.handleBlur}
                                            disabled={true}
                                        />
                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                    </div>
                                    :
                                    Fields.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className='w-[47%]'>
                                            <>
                                                <CustomSelection required options={Fields?.options}
                                                    {...formik?.getFieldProps(Fields?.question_no)}
                                                    name={Fields.question_no} label={Fields.question}
                                                />
                                                {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                        </div>
                                        
                                        
                                        : ''
                                }
                            </>
                        )}

                    {documents.map((Fields, index) => (
                <div key={index} className="w-[47%] flex items-center">
                    {Fields.type.toLowerCase() === 'attach' ? (
                        <>
                            <div className='flex-1'>
                                <CustomFileInput
                                    {...formik.getFieldProps(Fields.question_no)}
                                    value={Fields.question_no in attachmentUrls ? `File available for download` : ''}
                                    name={Fields.question_no}
                                    label={Fields.question}
                                    disabled
                                />
                                <ParagraphComp className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]" text={Fields.description} />
                            </div>
                            {attachmentUrls[Fields.question_no] && (
                                <div className='w-10 m-auto'>
                                    <a
                                        href={attachmentUrls[Fields.question_no]}
                                        download={`${Fields.question_no}_receipt.pdf`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <GetAppOutlinedIcon className='text-[#004878] m-2'/>
                                    </a>
                                </div>
                            )}
                        </>
                    ) :''}
                </div>
            ))}
                    </div>
                    


                </div>

                
            </form>

        </>
  )
}

export default DonationDocuments